import patch from "../../../patch";

const seeChats = (user_ids: number[]) =>
    patch(`chats`, {
        user_ids, seen: true
    });

export default seeChats;